// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/night-navigation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/night-navigation/night-navigation.js';

mount([g0]);
